import { Subject } from 'rxjs';

export const RowOffsetSubject = new Subject();
